module.exports = __webpack_public_path__ + "img/Patrick.3458700d.jpeg";